import Crud from '@/stores/crudBase';
import api from '@/apis/opening/openingAccountEntryAPI.js';
import commonFn from '@/commons/commonFunction';
var crud = new Crud('openingAccountEntry', api);

const state = {
  ...crud.state,
  _config: {
    table: 'opening_account_entry',
    field: {
      code: 'account_number',
      name: 'account_name',
      key: 'ref_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load tree
   */
  async loadTree(context, payload) {
    context.commit('updateLoading', true);

    let res = await api.getTree(payload || {});
    context.commit('updateLoading', false);

    if (res) {
      context.commit('setItems', res);
    }
  },

  /**
   * Lấy liệu cho màn list detail trừ tab vthh dùng entity khác
   * @param {*} context
   * @param {*} payload
   * @returns
   * nvtoan2 15/09/2022 sửa lại service để call lấy list detail cho tất cả các tab
   */
  async getAccountBalanceListDetail(context, payload) {
    return await api.getAccountBalanceListDetail(payload || {});
  },

  /**
   * Lấy thông tin detail
   * pthai - 31/07/2023
   */
  async getListDetail(context, payload) {
    return await api.getListDetail(payload || {});
  },

  /**
   * Xóa số dư tài khoản
   * Created by NNkiem 22.09.2022
   */
  async deleteAccountBlanace(context, payload) {
    let res = await api.deleteAccountBlanace(payload.filters || '');

    let errValidate = ['VALIDATE', 'Business', 'Exception'];
    let keyField = context.state._config.field.key;
    //Danh sách gửi lên xóa
    let deleted = [...payload.Models];
    if (keyField && res) {
      for (let i = 0; i < res.length; i++) {
        // Nếu không xóa được thì loại bỏ khỏi list xóa
        if (errValidate.find(x => x === res[i]?.Code)) {
          if (res[i] && res[i].Data && res[i].Data.Data) {
            let itemError = payload.Models[res[i].Index];
            //Loại đi những bản ghi không xóa được
            deleted = deleted.filter((item, index) => {
              return !(item[keyField] === res[i].Data.Data[keyField] || item[keyField] === itemError[keyField]);
            });
          }
        }
      }
    }
    //Commit thực hiện xóa
    context.commit('deleteItemsCustom');

    return res;
  },

  /**
   * Update multiple
   * bnanh 23.06.2022
   */
  async addAndUpdateData(context, param) {
    let res = await api.addAndUpdateData(param);
    return res;
  },

  /**
   * load dữ liệu, nhưng không gán thẳng vào state.items, tránh load lại grid
   * author: nqhuy1 12/10/2023
   */
  async reloadDataOpeing(context, payload) {
    let res = await api.getTree(payload || {});
    context.commit('updateDataOpening', res);
  },

  /**
   * Lấy số dư từ QLTS
   * NBTIN 09.02.2023
   */
  async getDataInitBalanceQLTS(context, payload) {
    let res = await api.getDataInitBalanceQLTS(payload);
    if (res) {
      return res;
    }
  },
};
const mutations = {
  ...crud.mutations,
  /**
   * map dư nợ, dư có của dữ liệu sau khi load với dữ liệu ban đầu (state.items)
   * author: nqhuy1 12/10/2023
   */
  updateDataOpening(state, data) {
    state.items.forEach(item => {
      const newItem = data.find(x => x.account_id == item.account_id);
      item.debit_amount = newItem.debit_amount;
      item.credit_amount = newItem.credit_amount;
    });
  },

  /**
   * hàm khi chỉ xóa dữ liệu của dòng mà không xóa cả dòng đó
   * author: nqhuy1
   */
  deleteItemsCustom(state, items) {
    //xóa cache combobox data
    if (state.cacheKeys) {
      commonFn.removeCacheComboboxData(state.cacheKeys);
    }
    state.version++;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
